import React, { ReactElement, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme, Accordion, AccordionDetails, AccordionSummary, Typography, Container, Box } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { LiveChatNotificationApiSettings } from '@alme/api-ts/LiveChat/LiveChatNotificationApiSettings';
import { HttpHandlerBase } from '@alme/api-ts/HttpHandlerBase';

interface AlmeEndLiveChatDialogProps {
    apiSettings: LiveChatNotificationApiSettings;
}

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
    createStyles({
        root: {
            border: `solid 1px ${palette.divider}`,
            padding: spacing(1),
        },
        boxWidth: {
            width: '60%',
        },
    }),
);

const ModuleVersion: React.FC<AlmeEndLiveChatDialogProps> = (props: AlmeEndLiveChatDialogProps): ReactElement => {
    const [moduleVersions, setModuleVersions] = useState<string>();

    const handleAccordionChange = async (event: React.ChangeEvent<unknown>, isExpanded: boolean) => {
        if(isExpanded && !moduleVersions) {
            try {
                  const handler = new HttpHandlerBase();
                  const endPoint = `${props.apiSettings.AlmeApiProtocol}${props.apiSettings.AlmeApiHostname}${props.apiSettings.AlmeApiBasePath}utils/getModuleVersions`;
                  const response = await handler.SendAsync<string[]>(endPoint);
                  setModuleVersions((response as []).join('\n'));
            } catch(e) {
                  console.log(e);
            }
        }
    };

    const classes = useStyles();
    return (
        <Container className={classes.root} >
            <Box className={classes.boxWidth}>
                <Typography variant='subtitle1'>Module Versions</Typography>
                <Accordion onChange={handleAccordionChange}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="alme-app-module-version-tool-content"
                        id="alme-app-module-version-tool"
                        >
                        <Typography variant='h6'>Get Module Versions</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Container>
                            {moduleVersions ?? ""}
                        </Container>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Container>
    );
};

export default ModuleVersion;